export default __webpack_public_path__ + "static/media/search.3bb6bf40.png";